var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 38414",
    filter: "url(#filter0_i_9688_50671)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9688_50671)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "url(#paint0_linear_9688_50671)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.8 30.2V40H10.2V30.2H19.8V40H20.2V30.2H29.8V40H30.2V30.2H40V29.8H30.2V20.2H40V19.8H30.2V10.2H40V9.8H30.2V0H29.8V9.8H20.2V0H19.8V9.8H10.2V0H9.8V9.8H0V10.2H9.8V19.8H0V20.2H9.8V29.8H0V30.2H9.8ZM10.2 29.8H19.8V20.2H10.2V29.8ZM20.2 29.8H29.8V20.2H20.2V29.8ZM29.8 10.2V19.8H20.2V10.2H29.8ZM10.2 19.8H19.8V10.2H10.2V19.8Z",
    fill: "url(#paint1_linear_9688_50671)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 26",
    d: "M31 15.8292V31C31 31.5523 30.5523 32 30 32H17C16.4477 32 16 31.5523 16 31V9.58923C16 8.85288 16.7689 8.36907 17.4327 8.68771L30.4327 14.9277C30.7794 15.0941 31 15.4446 31 15.8292Z",
    fill: "url(#paint2_linear_9688_50671)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 27",
    d: "M9 16.5707V31C9 31.5523 9.44772 32 10 32H21C21.5523 32 22 31.5523 22 31V21.7081C22 21.3197 21.7751 20.9664 21.4232 20.802L10.4232 15.6647C9.76015 15.355 9 15.839 9 16.5707Z",
    fill: "url(#paint3_linear_9688_50671)"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 136",
    cx: 34.5,
    cy: 12.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 138",
    cx: 24.5,
    cy: 7.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 137",
    cx: 11,
    cy: 11,
    r: 1,
    fill: "url(#paint4_linear_9688_50671)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_9688_50671",
    x: 0,
    y: 0,
    width: 40,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "lighten",
    in2: "shape",
    result: "effect1_innerShadow_9688_50671"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9688_50671",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC75B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F99312"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9688_50671",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9688_50671",
    x1: 23.5,
    y1: 8,
    x2: 23.5,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9688_50671",
    x1: 15.5,
    y1: 15,
    x2: 15.5,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9688_50671",
    x1: 11,
    y1: 10,
    x2: 11,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9688_50671"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.6978cdf18bde6721625156e809e9ae95.svg";
export { ForwardRef as ReactComponent };